import { css } from "styled-components";

export const inputField = css`
    height: 40px;
    padding: 5px 15px;
    border-radius: 5px;
    background: ${({ theme }) => theme.inputBg};
    border: 1px solid ${({ theme }) => theme.inputBorder};
`;
